/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Tame_Ox_PlanInputs */

const en_wise_tame_ox_plan = /** @type {(inputs: Wise_Tame_Ox_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating...`)
};

const de_wise_tame_ox_plan = /** @type {(inputs: Wise_Tame_Ox_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere...`)
};

/**
* | output |
* | --- |
* | "Updating..." |
*
* @param {Wise_Tame_Ox_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_tame_ox_plan = /** @type {((inputs?: Wise_Tame_Ox_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Tame_Ox_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_tame_ox_plan(inputs)
	return de_wise_tame_ox_plan(inputs)
});